import React, { Component, ErrorInfo, ReactNode } from "react";
import ErrorModal from "../../components/Modals/ErrorModal/ErrorModal";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(err: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {}

  unSetError() {
    this.setState({
      hasError: false,
    });
  }

  public render() {
    const { /* error, */ children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <React.Fragment>
          <Header />
          <ErrorModal
            hasError={hasError}
            unSetError={() => this.unSetError()}
          />
          <Footer />
        </React.Fragment>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
